import React from 'react'
import classNames from 'classnames/bind'
import styles from './AdminContent.module.scss'

const cx = classNames.bind(styles)

interface AdminContentProps {
  children: React.ReactNode
}

function AdminContent({ children }: AdminContentProps) {
  return (
    <main className={cx('content')}>
      {children}
    </main>
  )
}

export default AdminContent

